var _style, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShapeWatermelon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:none;stroke-width:3;stroke-linecap:round}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "shape",
    fill: "#ffc220",
    d: "M150 0C67.2 0 0 67.2 0 150h150V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "stroke st1",
    stroke: "currentColor",
    d: "M113.2 54.4c.5 1.5 1.3 3.1 1.3 4.7M90.4 82.4l3.4 3.4M124.4 94.9c.7 1 1.4 2 2.2 3M93 117.7l1.7 1.3M65 110.8c1.1.4 2 .8 3 1.3M58.6 131.4c1.9.4 3.7.8 5.6 1.3M124 125.8c1.1.7 2.3 1.6 3.4 2.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "stroke st1",
    stroke: "currentColor",
    d: "M20.6 150c0-71.4 58-129.4 129.4-129.4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeWatermelon);
export default __webpack_public_path__ + "static/media/shape-watermelon.d8f9ca9a.svg";
export { ForwardRef as ReactComponent };